<template>
  <div>
    <div class="header-sticky">
      <resend-bar />
      <Header />
    </div>
    <div class="mb-0 circle" @click="hideL">
      <div class="header-banner">
        <div class="banner-wrapper">
          <div>
            <h1 class="banner-heading">Join Health Conditions Based Circles</h1>
            <p class="banner-description">
              Helping you create social circles to manage your chronic conditions for a better life. You can also share your knowledge to help others manage their condition better.
            </p>
            <div class="btn-wrapper">
              <button class="cta-button" @click="() => goToSSO()" v-if="!authUser">Get Started</button>
              <!-- <button class="cta-button" @click="ssoLogin" v-if="!authUser">Get Started</button> -->
              <button :class="authUser ? 'cta-button' : 'cta-button search-btn'" @click="handleGoToSearchPage">Search Circles</button>
            </div>
          </div>
          <div class="banner-image-wrapper hide-in-mobile">
            <img src="../../../src/assets/images/banner-image.png" alt="banner" :style="{ width: '759px', height: '476px' }" />
          </div>
        </div>
        <!-- <div class="text-wrapper">
            <p class="m-0 title">
              Join MyCircles
            </p>
            <p class="text-small">
              Helping you create social circles to manage your chronic conditions
              for a better life.<br />
              You can also share your knowledge to help others manage their
              condition better.
            </p>

            <div class="d-flex justify-content-center  ">
              <div class="search-circles">
                <a-select
                  class="select-circle"
                  show-search
                  size="large"
                  notFoundContent=""
                  :value="searchKey ? searchKey : undefined"
                  placeholder="Search and join a circle"
                  :style="{ width: '100%', height: '45px' }"
                  :dropdownMenuStyle="{ color: 'red' }"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  @search="handleSearch"
                  @inputKeydown.enter="handleGoToSelectedCircle"
                >
                  <a-select-option v-for="d in searchList" :key="d.id">
                    <div class="d-flex" @click="goToSelectedCircle(d)">
                      <div
                        class="condition-color"
                        :style="{ background: d.color_code }"
                      ></div>
                      <div :style="{ 'font-weight': '700' }">
                        {{ d.condition_type }}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
                <button class="search-icon" @click="handleGoToSelectedCircle">
                  Let's go
                </button>
              </div>
            </div>
            <div @click="goToLearnSection" class="learn-more">
              Learn more
              <font-awesome-icon
                :style="{ 'font-size': '18px', 'margin-left': '10px' }"
                :icon="['fas', 'arrow-circle-down']"
              />
            </div>
          </div> -->
      </div>

      <div class="dovemed-wrapper-lg">
        <div class="circle">
          <router-view />
        </div>
      </div>
    </div>
    <!-- <AskForGFit ref="gfitmodal" :connectGoogle="connectGoogle" :connectApple="connectApple" :dont="dontConnect" /> -->
    <!-- <SSOModal ref="modal" /> -->
    <Footer />
  </div>
</template>

<style scoped lang="scss">
h1.banner-heading {
  font-size: 48px;
  font-weight: 900;
  color: #ffffff !important;
  line-height: 62px;
  width: 498px;
}

p.banner-description {
  margin: 24px 0;
  font-size: 16px;
  width: 529px;
  color: #ffffff !important;
}

.cta-button {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: #062b54;
  padding: 12px 24px;
  color: #ffffff;
  outline: none;
  font-size: 14px;
  border-radius: 6px;
  border-style: none;
}

.search-btn {
  margin: 0 24px;
}
.title-text {
  font-size: 24px;
  font-weight: bold;
  line-height: 36px;
  padding-bottom: 24px;

  &--black {
    font-size: 32px;
    font-weight: bold;
    line-height: 36px;
    padding-bottom: 50px;
    color: #333333;
    text-align: center;
  }
}

.text-small {
  color: #ffffff;
  text-align: center;
  margin-top: 24px;
  font-size: 16px;
  line-height: 19px;
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
  &--black {
    padding-top: 80px;
    font-size: 12px;
    color: #333333;
    text-align: center;
  }
}

.author-name {
  font-size: 16px;
  font-weight: bold;
  line-height: 0;
  text-align: center;
}
.author-circle {
  font-size: 15px;
  text-align: center;
}
.advertise-text {
  position: relative;
}
.advertise-text > h5 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 25px;
}
.advertise-text > p {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}
.contact-us-btn {
  box-sizing: border-box;
  border: 1px solid #ffffff;
  color: #ffffff !important;
  padding: 15px 36px;
  border-radius: 50px;
  margin-top: 45px;
  background: transparent;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}
.advert-carousel-container {
  position: relative;
  padding-top: 100px;
}
.advertise-carousel {
  min-height: 200px;
  width: 40%;
  border: 1px solid #d6d6d6;
  border-radius: 3px;
  background-color: #ffffff;
  position: absolute;
  padding: 20px;
  right: 20px;
  top: -70%;
}

.header-banner {
  min-height: 476px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: unset;
  @media screen and (max-width: 600px) {
    padding-left: 20px;
  }
  .banner-wrapper {
    display: flex;
    align-items: center;
    margin: auto;
    max-width: 1200px;
  }
}

.header-banner > .text-wrapper > .title {
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 44px;
  @media screen and (max-width: 900px) {
    font-size: 30px;
  }
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}

.condition-color {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 5px;
}
.search-icon {
  position: absolute;
  right: 5px;
  top: 3px;
  background-color: #062b54;
  border-radius: 5px;
  color: #ffffff;
  padding: 6px 20px;
  font-size: 15px;
  border: none;

  &:focus {
    outline: none;
  }

  @media screen and (max-width: 900px) {
    position: relative;
    width: 100%;
    right: 0px;
    top: 0px;
  }
  @media screen and (max-width: 600px) {
    position: relative;
    width: 100%;
    right: 0px;
    top: 0px;
  }
}
.ant-select-selection {
  &--single {
    height: 45px !important;
  }
}

a-select {
  font-size: 14px;
  padding: 3px;
}
.search-circles {
  position: relative;
  width: 50%;
  margin-top: 48px;
  // margin-bottom: 80px;

  @media screen and (max-width: 900px) {
    margin-top: 20px;
  }
  @media screen and (max-width: 600px) {
    margin-top: 20px;
  }

  .ant-select-selection {
    &--single {
      height: 45px !important;
    }
  }

  input {
    height: 45px;
  }

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}
.learn-more {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  margin: 36px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  letter-spacing: 2px;
  cursor: pointer;
}
.select-circle {
  font-size: 12px;
  font-weight: bold;
  .ant-select-selection__placeholder {
    color: red !important;
  }
}
.ant-select-selection__placeholder {
  color: blue;
}

.fit-content {
  height: fit-content;
}
.placeholder-text {
  color: red;
}
.dovemed-link {
  width: 100%;
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
.header-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}
@media screen and (max-width: 768px) {
  .btn-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  h1.banner-heading {
    font-size: 36px;
    line-height: 46px;
    width: auto !important;
    margin-right: 20px;
    text-align: center;
  }
  p.banner-description {
    margin-right: 20px;
    margin-bottom: 80px !important;
    text-align: center;
    width: auto !important;
  }
  .banner-wrapper {
    margin-left: 20px;
    margin-top: 48px !important;
    margin-bottom: 62px !important;
  }
  .search-btn {
    margin-left: 0 !important;
  }
  .cta-button {
    margin-right: 20px;
  }
}
</style>

<script>
import Header from "./HeaderGeneric"
import Footer from "./FooterGeneric"
// import SSOLogin from "../login/login-register-component"
// import SSOModal from "../login/login-register-modal.vue"
import ResendBar from "./resendBar.vue"
import { mapState } from "vuex"
// import { RepositoryFactory } from "../../repositories/RepositoryFactory"
// import AskForGFit from "../Modals/AskForGFit.vue"

// const CircleRepository = RepositoryFactory.get("circle")

export default {
  name: "CircleLayout",
  components: {
    Header,
    Footer,
    ResendBar,
    // SSOLogin,
    // SSOModal,
    // AskForGFit,
  },

  data: function() {
    return {
      // showContent: false,
      // searchKey: undefined,
      // searchList: [],
      // showResendEmail: false,
      // membersComments: [
      //   "This is a great place to meet others that are going through similar problems, get advice and help cope with the daily struggles.”Daniel T",
      //   "“The MyCircles is an excellent platform for people with chronic disorders to share their varied experiences, ask questions, and stay connected with others having the same disorder.”Joseph K",
      // ],
      // members: [1],
      // client_id: "703299315924-8e04nejnfboidhic7k0vhu42e8056kt7.apps.googleusercontent.com",
      // client_id: "101951622305-r97l0t8dvq817olgmshsrjrekmuna8k1.apps.googleusercontent.com",
      // connectDD: true,
    }
  },

  created() {
    console.warn('CircleLayout.vue is created');
    // if (this.authUser) {
    //   if (this.authUser.user.hasOwnProperty("verified_account") && this.authUser.user.verified_account === false) {
    //     this.showResendEmail = true
    //   }
    // }
  },

  mounted() {
    // if (!this.authUser) {
    //   // return
    //   const userAgent = navigator.userAgent || window.opera
    //   if (/android/i.test(userAgent)) {
    //     const localData = JSON.parse(localStorage.getItem("gFitInfo"))
    //     if (this.$route.query.code) {
    //       localStorage.setItem("gFitInfo", JSON.stringify({ allowed: true, auth_code: this.$route.query.code }))
    //       return
    //     }
    //     if (localData && localData.allowed) {
    //       this.connectGoogle()
    //       return
    //     }
    //     if (!localData) {
    //       localStorage.setItem("gFitInfo", JSON.stringify({ allowed: false, auth_code: "" }))
    //     }
    //     if (localData && !localData.allowed) {
    //       this.$refs.gfitmodal.show()
    //     }
    //   }
    // }


    // const localData = JSON.parse(localStorage.getItem("gFitInfo"))
    // console.log("1 localData:", localData)
    // if (this.$route.query.code) {
    //   localStorage.setItem("gFitInfo", JSON.stringify({ allowed: true, auth_code: this.$route.query.code }))
    //   return
    // }
    // if (localData && !localData.allowed) {
    //   return
    // }
    // if (localData && localData.allowed) {
    //   this.connectGoogle()
    //   return
    // }
    // if (!localData && this.connectDD) {
    //   console.log("2 localData:", localData)
    //   localStorage.setItem("gFitInfo", JSON.stringify({ allowed: false, auth_code: "" }))
    //   console.log("3 localData:", JSON.parse(localStorage.getItem("gFitInfo")))
    //   // this.$refs.gfitmodal.show()
    // }
  },

  computed: {
    // ...mapState({ resendMail: state => state.App.resendMail }),
    // ...mapGetters({ modalState: "SsoLogin/modalState" }),
  },

  // watch: {
  //   modalState: {
  //     handler(v) {
  //       if (v) {
  //         this.ssoLogin()
  //       }
  //     },
  //     immediate: true,
  //   },
  // },

  methods: {
    goToSSO() {
      window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${process.env.SSO_BASE_URL}/mycircles`
    },
    // dontConnect() {
    //   localStorage.setItem("gFitInfo", JSON.stringify({ allowed: false, auth_code: "" }))
    //   this.connectDD = false
    // },
    // connectGoogle() {
    //   window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/fitness.activity.read+https://www.googleapis.com/auth/fitness.body.read+https://www.googleapis.com/auth/fitness.body_temperature.read+https://www.googleapis.com/auth/fitness.heart_rate.read+https://www.googleapis.com/auth/fitness.sleep.read&access_type=offline&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=${process.env.SSO_BASE_URL}/mycircles&response_type=code&client_id=${this.client_id}`
    //   // https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/fitness.activity.read+https://www.googleapis.com/auth/fitness.body.read+https://www.googleapis.com/auth/fitness.body_temperature.read+https://www.googleapis.com/auth/fitness.heart_rate.read+https://www.googleapis.com/auth/fitness.sleep.read&access_type=offline&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=https://staging.cluster.dovemed.com/mycircles&response_type=code&client_id=101951622305-r97l0t8dvq817olgmshsrjrekmuna8k1.apps.googleusercontent.com
    // },
    // toggleContent() {
    //   this.showContent = !this.showContent
    // },
    // goToLearnSection() {
    //   document.getElementById("learn-more").scrollIntoView()
    // },
    hideL() {
      if (this.$el.querySelector(".left-sidebar").classList.contains("left-sidebar-show")) {
        this.$el.querySelector(".left-sidebar").classList.remove("left-sidebar-show")
      }
      this.$el.querySelector(".left-sidebar").classList.add("left-sidebar-hide")
      document.querySelector("#app").classList.remove("no-scroll")
    },
    // handleSearch(val = "") {
    //   this.searchKey = val
    //   CircleRepository.all(val, "").then(res => {
    //     this.searchList = res.data.data.all_circles
    //   })
    // },
    // goToSelectedCircle(data) {
    //   this.searchKey = data.condition_type

    //   this.$router.push({
    //     name: "searchCircle",
    //     params: { search: data.id, type: "number" },
    //   })
    // },
    // handleGoToSelectedCircle() {
    //   if (this.searchKey) {
    //     this.$router.push({
    //       name: "searchCircle",

    //       params: {
    //         search: this.searchKey,
    //         type: "string",
    //       },
    //     })
    //   } else {
    //     this.$notification.error({
    //       message: "Error",
    //       description: "Please enter a condition",
    //     })
    //   }
    // },
    // ssoLogin() {
    //   document.body.scrollTop = 0
    //   this.$store.commit("SsoLogin/openModal")
    //   this.$refs.modal.open()
    // },
    handleGoToSearchPage() {
      // if (this.authUser) {
      //   this.$router.push({ path: "/searchpage" }).catch(err => {});
      // } else {
      //   this.$router.push({ path: "/searchpage/default/all" }).catch(err => {});
      // }
      this.$router.push({ path: "/searchpage/default/all" }).catch(err => {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/App/CircleLayout.vue